import React, { useCallback, useEffect, useState } from 'react';

import {
  CloudAccountGetResponse,
  CloudProviders,
} from '@ariksa/cloud-account/api';
import { each, map } from 'lodash';
import filter from 'lodash/filter';
import { useSelector } from 'react-redux';

import { getIcon } from 'components/Icons/Components';
import { selectApp } from 'containers/App/selectors';

export const useCloudAccounts = () => {
  const { cloudAccounts } = useSelector(selectApp);
  const [providerAccountMapping, setProviderAccountMapping] = useState<
    Record<string, CloudAccountGetResponse[]>
  >({});

  useEffect(() => {
    const items: Record<string, CloudAccountGetResponse[]> = {};
    each(cloudAccounts.data, o =>
      !!items?.[o.cloud_type!]
        ? items[o.cloud_type!].push(o)
        : (items[o.cloud_type!] = [o]),
    );
    setProviderAccountMapping(items);
  }, [cloudAccounts.data]);

  const getAccountOptions = useCallback(
    (cloudProvider?: CloudProviders) => {
      let accounts = cloudAccounts.data;
      if (!!cloudProvider)
        accounts = filter(
          cloudAccounts.data,
          (a: CloudAccountGetResponse) => a.cloud_type === cloudProvider,
        );
      return map(accounts, a => ({
        label: a?.name + ' (' + a?.cloud_account_id + ')',
        value: a?.uuid,
        icon: getIcon(a?.cloud_type!),
        data: a,
      }));
    },
    [cloudAccounts.data],
  );

  return {
    getAccountOptions,
    providerAccountMapping,
  };
};
